
let devToken = null

// paste prod jwt hereand uncomment while in development
// devToken =  ""


export default devToken


// WEBPACK FOOTER //
// ./src/actions/devToken.js